import { GET_RELEASE_NOTES, SET_RELEASE_NOTES } from "./actionTypes";

export const fetchReleaseNotes = () => {
  return { type: GET_RELEASE_NOTES };
};

export const setReleaseNotes = (data: string) => {
  return { type: SET_RELEASE_NOTES, payload: data };
};
